import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";

import Storage from "@/core/config/Storage";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(() => {
  if (!Storage.getSound()) {
    Storage.setSound(true);
  } else {
    Storage.setSound(Storage.getSound());
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})